(()=>{'use strict';
  function initCookies() {
    var box = document.querySelector('[data-cb-cookies]');
    if (!box) return;
    var prefs = box.querySelector('[data-cb-cookies-prefs]');
    var btnConfig = box.querySelector('[data-cb-ck-config]');
    var btnSave = box.querySelector('[data-cb-ck-save]');
    var KEY = 'cb-cookies-v1';

    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function close() { box.hidden = true; }
    function open() { box.hidden = false; }

    function send(c) {
      remember(); close();
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, function () {});
      }
    }
    function choose(all) {
      send({ analytics: all, marketing: all, preferences: all });
    }

    function decide() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && api.currentVisitorConsent) {
        var c = api.currentVisitorConsent() || {};
        if (c.analytics === '' || c.marketing === '' || typeof c.analytics === 'undefined') { if (!stored()) open(); }
      } else if (!stored()) {
        open();
      }
    }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { decide(); });
    } else {
      decide();
    }

    box.querySelector('[data-cb-ck-accept]').addEventListener('click', function () { choose(true); });
    box.querySelector('[data-cb-ck-reject]').addEventListener('click', function () { choose(false); });
    btnConfig.addEventListener('click', function () {
      prefs.hidden = false; btnConfig.hidden = true; btnSave.hidden = false;
    });
    btnSave.addEventListener('click', function () {
      function v(n) { var i = box.querySelector('[data-cb-ck="' + n + '"]'); return !!(i && i.checked); }
      send({ analytics: v('analytics'), marketing: v('marketing'), preferences: v('preferences') });
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cb-ck-open]');
      if (t) { e.preventDefault(); open(); prefs.hidden = false; btnConfig.hidden = true; btnSave.hidden = false; }
    });
  }


if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initCookies);else initCookies();})();